export default {
    MOVING_INFO_NOTICE: "Выберите груз из списка или воспользуйтесь поиском",
    PLEASE_WAIT: "Пожалуйста, подождите",
    RESTORE_PASSWORD: "Восстановление пароля",
    RESTORE_PASSWORD_EMAIL_PLAN: `Введите адрес электронной почты, который был указан 
                                  при регистрации и мы вышлем инструкцию по восстановлению пароля`,
    RESTORE_PASSWORD_PHONE_PLAN: `Введите номер вашего мобильного телефона и мы вышлем код для восстановления пароля`,
    RESTORE_PASSWORD_EMAIL_INFO: `На указанную почту будет выслано письмо с кодом, введя который вы получите  возможность сменить пароль
                                  на новый. В случае, если письмо не приходит в течение 5 минут, проверьте правильность 
                                  ввода электронной почты или проверьте папку «спам»`,
    RESTORE_PASSWORD_SMS_INFO: `На указанный номер будет выслан код, введя который вы получите возможность сменить пароль. 
                                  В случае, если код не приходит в течение 1 минуты, проверьте правильность 
                                  ввода номера телефона`,
    CONTINUE: "Продолжить",
    NEED_SUPPORT_HELP: `Если вам нужна дополнительная помощь, обратитесь в 
                        службу поддержки по телефону 8(800)555-19-23. 
                        Звонки по России бесплатно`,
    YOUR_EMAIL: "Ваша электронная почта",
    CODE_FROM_EMAIL: "Код из письма",
    CODE_FROM_SMS: "Код из SMS",
    CHANGE_ADDRESS: "Изменить адрес",
    CHANGE_PHONE_NUMBER: "Изменить номер",
    SEND_CODE_AGAIN: "Отправить код еще раз",
    EMAIL_WITH_BRIEF_SENT: "Письмо с инструкцией отправлено по адресу",
    SMS_WITH_BRIEF_SENT: "Введите код, высланный на номер вашего мобильного телефона",
    YOU_PROVIDED: "который вы указали",
    RESTORE_PASSWORD_AFTER_NEW_PASSWORD_INFO: "После ввода нового пароля мы авторизуем вас и разместим вашу заявку на сайте",
    ENTER_NEW_PASSWORD: "Введите новый пароль",
    NEW_PASSWORD: "Новый пароль",
    REPEAT_NEW_PASSWORD: "Повторите новый пароль",
    REPEAT_PASSWORD: "Повторите пароль",
    SET_NEW_PASSWORD: "Установить новый пароль",
    AND: "и",
    ADD_ORDER: "разместить заявку",
    SAVE: "Сохранить",
    CANCEL: "Отменить",
    EXPECTED: "Возможно вы имели в виду",
    M: "м",
    CM: "см",
    KG: "кг",
    T: "т",
    TYPE_STUFF_NAME_HERE: "Укажите свой груз",
    ADD_TO_LIST: "Добавить в список",
    SELECT_CATEGORY: "Выберите категорию",
    THIS_IS_NEW_STUFF_FOR_US: "Это новый для нас груз, вы можете добавить его в ваш список",
    HERE_YOU_WILL_SEE_YOUR_STUFF: "Здесь появятся добавленные вами грузы",
    ADD_NEW_ADDRESS: "Добавить новый адрес",
    ONE_PLACE_PARAMS: "Параметры одного места",
    TOTAL_WEIGHT: "Общий вec",
    TOTAL_VOLUME: "Общий объём",
    NEXT_STEP: "Далее",
    BACK: "Назад",
}



// WEBPACK FOOTER //
// ./client/lang/ru/text.js